import router from '@/router';
import { ClientUtil, UrlUtil } from '@xl/js-utils/lib';
import ua from '@xl/user-agent';
import { AppModule } from '@/store/modules/app';
import { loadScript } from './utils';
import { WEIXIN_JSDK_URL } from '@/config';
const { is_xl_driver_app, isInWeixinMini, isInWeixinApp } = ua.parse();
export const jumpLogin = async() => {
  // 可能有小拉用户app打开
  if (is_xl_driver_app) {
    ClientUtil.webcall({
      action: 'login',
    });
    return;
  }
  if (isInWeixinMini) {
    await loadingWexinJSDK();
    if (!window.wx) return;
    console.log('小程序内navigateback', window.wx);
    window.wx.miniProgram.navigateBack();
    return;
  }
  // 其他跳转register
  const { token, driver_id, ...arg } = AppModule.urlParams || {};
  // 顺风车跳到顺风车注册
  const allUrlParams = UrlUtil.queryParse(window.location.href);
  const path = allUrlParams.is_carpool ? '/carpool-register' : '/register';
  // 删除token
  AppModule.SET_TOKEN('');
  AppModule.SET_URL_PARAMS({
    ...(arg || {}),
  });
  router.push({
    path,
    query: {
      ...(arg || {}),
      isRetainPage: '1',
    },
  });
};

export const loadingWexinJSDK = async() => {
  return new Promise((resolve, reject) => {
    if (window.wx) {
      resolve(true);
    } else {
      loadScript(WEIXIN_JSDK_URL, () => {
        if (!window.wx) {
          reject(new Error('微信JSSDK加载失败'));
        } else {
          resolve(true);
        }
      });
    }
  });
};
